import navigation from './components/navigation'
import skipLinks from './components/skip-links';
import tables from './components/tables';
import accordions from './components/accordions';
import dialogs from './components/dialogs';
import tabs from './components/tablist';
import searchToggle from './components/search-toggle';
import readMore from './components/read-more';
import backToOverview from './components/back-to-overview';
import affiliate from './components/affiliate';
import pageToc from './components/page-toc';
import formTracking from './components/form-tracking';
import trustpilotLoader from './components/trustpilot-loader';

tabs( document.querySelectorAll( '.tabs' ) );
skipLinks( document.getElementById( 'skip-to-content' ) );
navigation( document.querySelector( '.header__nav' ) )
tables( document.querySelectorAll( 'table' ) );
accordions( document.querySelectorAll( 'details' ) );
dialogs( document.querySelectorAll( '[data-open-dialog]' ), document.querySelectorAll( '[data-close-dialog]' ), document.querySelectorAll( '[data-dialog]' ) );
searchToggle( document.querySelector( '.header__search-toggle' ) );
readMore();
backToOverview();
affiliate( window.acato_variables );
pageToc();
formTracking();
trustpilotLoader();
